import { IApp } from '@/types/nuxt'
import { legacy as refresh } from '@/utils/refresh'

export default class MeUseCase implements BaseUseCase {
  constructor(protected App: IApp) {}

  async execute() {
    try {
      await refresh(this.App)
      this.App.legacy.user = await this.App.legacyGateway.Auth.Me()
      return true
    } catch (exception: any) {
      console.error(exception)
      if (exception.statusCode === 401) {
        location.href = '/legacy/login'
      }
    }
    return false
  }
}
